import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ResolveAssetPipe } from 'app/backpack/resolve-asset.pipe';
import * as moment from 'moment';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	selector: 'sp-calendar-month-nav',
	template: `
		<div class="month-nav">
			<button type="button" *ngIf="!isDisabledPreviousMonthButton" class="switch-month __left" (click)="prevMonth()">
				<img class="month-icon" [src]="'./assets/Chevron Left (Navy).svg' | resolveAsset" alt="Previous Month" />
			</button>

			<div class="switch-month __left disabled" *ngIf="isDisabledPreviousMonthButton">
				<img style="width: 15px" [src]="'./assets/Chevron Left (Blue-Gray).svg' | resolveAsset" />
			</div>

			<span class="ds-dialog-subtitle"
				>{{ currentDate.format('MMMM') }} <var>{{ currentDate.format('YYYY') }}</var></span
			>
			<button type="button" *ngIf="!isDisabledNextMonthButton" class="switch-month __right" (click)="nextMonth()">
				<img class="month-icon" [src]="'./assets/Chevron Right (Navy).svg' | resolveAsset" alt="Next Month" />
			</button>

			<div class="switch-month __right disabled" *ngIf="isDisabledNextMonthButton">
				<img class="month-icon" [src]="'./assets/Chevron Right (Blue-Gray).svg' | resolveAsset" alt="next" />
			</div>
		</div>
	`,
	styles: [
		`
			.month-nav {
				height: 50px;
				padding: 5px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				position: relative;
				.switch-month {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					border-radius: 50%;
					cursor: pointer;
					height: 32px;
					width: 32px;
					border: none;
					background: transparent;
					&.__right {
						right: 0;
						border: none;
						outline: none;
					}
					&.__left {
						left: 0;
						border: none;
						outline: none;
					}
					&:hover {
						background: $gray050;
					}
					&:active {
						background: $gray150;
					}
					&.disabled {
						cursor: default;
						&:hover {
							background-color: transparent;
							box-shadow: none;
						}
					}
					.month-icon {
						width: 15px;
					}
				}
			}
		`,
	],
	imports: [CommonModule, ResolveAssetPipe],
})
export class CalendarMonthNavComponent {
	@Input() min: moment.Moment | undefined;
	@Input() max: moment.Moment | undefined;
	@Input() currentDate: moment.Moment = moment();
	@Output() monthChange = new EventEmitter<moment.Moment>();

	get isDisabledPreviousMonthButton(): boolean {
		return this.min != undefined && this.currentDate.isSameOrBefore(this.min, 'month');
	}

	get isDisabledNextMonthButton(): boolean {
		return this.max != undefined && this.currentDate.isSameOrAfter(this.max, 'month');
	}

	prevMonth(): void {
		this.monthChange.emit(this.currentDate.clone().subtract(1, 'month'));
	}

	nextMonth(): void {
		this.monthChange.emit(this.currentDate.clone().add(1, 'month'));
	}
}
